<div class="columns">
    <div class="column is-1"></div>

    <div class="column is-10 mt-6">
        <div class="columns">
            <div class="column is-9"></div>
            <div class="column">
                <input class="border-input" type="text" placeholder="Suche" [(ngModel)]="searchText" (input)="onSearchInputChange()">
            </div>
        </div>


        <div class="columns mt-3">
            <div class="column is-half has-text-centered">
                <p class="is-size-2 is-clickable is-relative is-inline-block color-light-gray"
                   [ngClass]="{'selected': selectedTab === 'Portfolioverwaltung'}"
                   (click)="selectTab('Portfolioverwaltung')">Portfolioverwaltung</p>
            </div>
            <div class="column is-half has-text-centered">
                <p class="is-size-2 is-clickable is-relative is-inline-block color-light-gray"
                   [ngClass]="{'selected': selectedTab === 'Turnusbestellungen'}"
                   (click)="selectTab('Turnusbestellungen')">Turnusbestellungen</p>
            </div>
        </div>
        <div *ngIf="platformProfile" class="card has-round-border">
            <div *ngIf="!loadingSavedProperties" class="card-content">
                <app-portfolio-management [platformProfile]="platformProfile" *ngIf="selectedTab === 'Portfolioverwaltung'"></app-portfolio-management>
                <app-rotation-order-management [platformProfile]="platformProfile" *ngIf="selectedTab === 'Turnusbestellungen'"></app-rotation-order-management>
            </div>
        </div>

        <div *ngIf="!platformProfile || (!platformProfile.properties && loadingSavedProperties)" class="card has-round-border">
            <div class="card-content">
                <div class="columns">
                    <div class="column has-background-darkblue has-round-border has-text-white">
                        <div class="columns">
                            <div class="column is-1 has-text-centered w-5">ID</div>
                            <div class="column is-2 has-text-centered">Name</div>
                            <div class="column is-3 has-text-centered">Straße</div>
                            <div class="column is-1 has-text-centered">PLZ</div>
                            <div class="column is-2 has-text-centered">Ort</div>
                            <div class="column is-3 has-text-centered w-30">
                                <a class="custom-a-button inverted smaller-a-button does-not-wrap pl-4 pr-4">
                                    + Objekt hinzufügen
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-3" *ngFor="let n of [].constructor(3)">
                    <div class="card has-round-border line-height-is-3" style="height: 4rem">
                        <div class="columns margin-auto">
                            <div class="column is-1 has-text-centered w-5">
                                <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                                     animation="progress" appearance="line" count="1">
                                </ngx-skeleton-loader>
                            </div>
                            <div class="column is-2 has-text-centered">
                                <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                                     animation="progress" appearance="line" count="1">
                                </ngx-skeleton-loader>
                            </div>
                            <div class="column is-3 has-text-centered">
                                <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                                     animation="progress" appearance="line" count="1">
                                </ngx-skeleton-loader>
                            </div>
                            <div class="column is-1 has-text-centered">
                                <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                                     animation="progress" appearance="line" count="1">
                                </ngx-skeleton-loader>
                            </div>
                            <div class="column is-2 has-text-centered">
                                <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                                     animation="progress" appearance="line" count="1">
                                </ngx-skeleton-loader>
                            </div>
                            <div class="column is-3 has-text-centered w-30">
                                <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                                     animation="progress" appearance="line" count="1">
                                </ngx-skeleton-loader>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>

    <div class="column is-1"></div>
</div>
